import React from 'react';
import { Bike, Bus, Car, CarTaxiFront, Layers, Lock, Truck, Caravan } from 'lucide-react';
import { PageHeader } from '../../components/common/PageHeader';
import { Panel } from '../../components/common/Panel';
import { StatusBadge } from '../../components/common/StatusBadge';
const future = [{
  icon: Car,
  bn: 'ব্যক্তিগত গাড়ি',
  en: 'Private Car',
  prefix: 'CAR-'
}, {
  icon: Bus,
  bn: 'বাস',
  en: 'Bus',
  prefix: 'BUS-'
}, {
  icon: Truck,
  bn: 'ট্রাক',
  en: 'Truck',
  prefix: 'TRK-'
}, {
  icon: Bike,
  bn: 'মোটরসাইকেল',
  en: 'Motorcycle',
  prefix: 'MCL-'
}, {
  icon: Caravan,
  bn: 'অন্যান্য যানবাহন',
  en: 'Other Motor Vehicles',
  prefix: 'OTH-'
}];
export function Expansion() {
  return <div className="space-y-4" data-id="element-2008" data-mp="390pbbgbbm1fk">
      <PageHeader title="ভবিষ্যৎ সম্প্রসারণ" subtitle="Future Expansion — একই প্ল্যাটফর্ম, মডিউলভিত্তিক সম্প্রসারণ। নিচের যানবাহনগুলো প্রথম পর্যায়ের অংশ নয়।" data-id="element-2009" data-mp="390z23646wcmb" />
      <Panel data-id="element-2010" data-mp="o9oxrhw13y2m">
        <div className="flex flex-wrap items-center gap-5 rounded-lg border-2 border-bdgreen-600 bg-bdgreen-50 p-5" data-id="element-2011" data-mp="o970chxmrdt4">
          <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-bdgreen-600 text-white" data-id="element-2012" data-mp="1ma14bbldpqep"><CarTaxiFront className="h-9 w-9" data-id="element-2013" data-mp="1hdkfef6cv80k" /></span>
          <div className="flex-1" data-id="element-2014" data-mp="1cd63un5jpfxs">
            <StatusBadge tone="green" data-id="element-2015" data-mp="1cc4uqo83b3ip">প্রথম পর্যায় — চলমান</StatusBadge>
            <p className="mt-1 font-heading text-xl font-bold text-navy-900" data-id="element-2016" data-mp="18bumt60qm317">সিএনজি অটোরিকশা</p>
            <p className="text-sm text-slate-600" data-id="element-2017" data-mp="13c80m72xlcg9">ডিএমপি এলাকার প্রায় ১৭,০০০ সিএনজি • QR প্রিফিক্স <span className="font-mono" data-id="element-2018" data-mp="ylrmslv77otd">CNG-</span></p>
          </div>
        </div>
        <p className="mb-3 mt-6 text-sm font-semibold text-slate-500" data-id="element-2019" data-mp="yjoo7dfzcnd1">পরবর্তী পর্যায়</p>
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-5" data-id="element-2020" data-mp="tmy66kkm7hoz">
          {future.map(f => <div key={f.en} className="relative rounded-lg border border-dashed border-slate-300 bg-white p-4 text-center" data-id="element-2021" data-mp="opet3nznlaym">
              <Lock className="absolute right-3 top-3 h-3.5 w-3.5 text-slate-300" data-id="element-2022" data-mp="fmx6h8g36gb3" />
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-500" data-id="element-2023" data-mp="fp03wdjkjbpu"><f.icon className="h-6 w-6" strokeWidth={1.6} data-id="element-2024" data-mp="61ns0yo0i9n3" /></span>
              <p className="mt-2 font-semibold text-navy-900" data-id="element-2025" data-mp="a2g21u4pkikf">{f.bn}</p>
              <p className="text-xs text-slate-500" data-id="element-2026" data-mp="3s7jejzx07wuv">{f.en}</p>
              <p className="mt-2 font-mono text-[11px] text-slate-400" data-id="element-2027" data-mp="106wzjs7lhef">{f.prefix}000001</p>
              <StatusBadge tone="gray" className="mt-2" data-id="element-2028" data-mp="121fkrg0cxfc">পরিকল্পিত</StatusBadge>
            </div>)}
        </div>
      </Panel>
      <Panel title="সম্প্রসারণযোগ্য স্থাপত্য" subtitle="নতুন যানবাহন যুক্ত করতে মূল সিস্টেম পরিবর্তনের প্রয়োজন নেই" data-id="element-2029" data-mp="tp5fii08ulk9">
        <div className="grid gap-3 md:grid-cols-3" data-id="element-2030" data-mp="ez6jolw5vm7y">
          {[['যানবাহন ধরন মাস্টার', 'নতুন যানবাহন ধরন, QR প্রিফিক্স ও প্রয়োজনীয় ডকুমেন্ট কনফিগারেশনের মাধ্যমে যুক্ত'], ['অভিন্ন BRTA ইন্টিগ্রেশন', 'একই Vehicle Registration, Fitness, Tax ও License API সকল যানবাহনের জন্য ব্যবহারযোগ্য'], ['একই মোবাইল অ্যাপ', 'ট্রাফিক পুলিশ একই অ্যাপে যেকোনো যানবাহনের QR স্ক্যান করবেন — ফলাফল ধরনভেদে প্রদর্শিত']].map(([t, d]) => <div key={t} className="rounded-md border border-border p-4" data-id="element-2031" data-mp="2s77jau6rgq8x">
              <Layers className="h-5 w-5 text-navy-700" data-id="element-2032" data-mp="2s4v0yfx3cdvc" />
              <p className="mt-2 font-semibold text-navy-900" data-id="element-2033" data-mp="35wsw1mtyw98i">{t}</p>
              <p className="mt-1 text-sm text-slate-600" data-id="element-2034" data-mp="31vz84tgiyufm">{d}</p>
            </div>)}
        </div>
      </Panel>
    </div>;
}